module.exports = __webpack_public_path__ + "img/people-2.c521a4d3.svg";